import React from "react";
import PropTypes from 'prop-types';

import { MaterialSwitch, SideItemText } from './styled';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import { ThemedComponent } from "ui/theme";

export const Toggle = ({ checked, onChange, label, title, secondary }) => {
    const action = (event) => {
        const nv = !!event?.target?.checked;
        if (onChange && typeof onChange === 'function') onChange(nv, event);
    };

    return (
        <ThemedComponent>
            <FormGroup>
                {title ? (
                    <FormLabel component="legend" color={secondary ? 'secondary' : 'primary'}>
                        {title}
                    </FormLabel>
                ) : null}

                <FormControlLabel
                    sx={{
                        margin: 0,
                        gap: '8px',
                        alignItems: 'center',
                    }}
                    control={
                        <MaterialSwitch
                            checked={!!checked}
                            onChange={action}
                            color={secondary ? 'secondary' : 'primary'}
                        />
                    }
                    label={<SideItemText>{label}</SideItemText>}
                />
            </FormGroup>
        </ThemedComponent>
    );
};

Toggle.propTypes = {
    label: PropTypes.string.isRequired,
    title: PropTypes.string,
    checked: PropTypes.bool,
    secondary: PropTypes.bool,
    onChange: PropTypes.func,
};

Toggle.defaultProps = {
    label: '',
    title: '',
    checked: false,
    secondary: false,
    onChange: undefined,
};

export default Toggle;
